import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSystemAlert } from './useApi/useSystemAlert';
import { useStandardAlertStore } from '../store/portal/alertStore';
import { AlertPosition, AlertType, SystemAlertType } from '../enum/EnumRepository';


export const useGlobalSystemAlert = () => {
  const { getSystemAlertList, systemAlertList } = useSystemAlert();
  const { enqueueAlert } = useStandardAlertStore();
  const { pathname } = useLocation();

  // /admin 경로가 아닐 때만 getSystemAlertList 호출
  useEffect(() => {
    if (!pathname.includes('/admin')) {
      getSystemAlertList();
    }
  }, [pathname]);


  useEffect(() => {
    if (systemAlertList.length > 0) {
      // EMERGENCY 우선순위 확인
      const emergencyAlert = systemAlertList.find(alert => alert.type === SystemAlertType.EMERGENCY);
      if (emergencyAlert) {
        enqueueAlert({
          type: AlertType.EMERGENCY,
          position: AlertPosition.CENTER,
          content: emergencyAlert.message,
        });
        return;
      }
      
      // EMERGENCY가 없는 상태에서 MAINTENANCE 확인
      const maintenanceAlert = systemAlertList.find(alert => alert.type === SystemAlertType.MAINTENANCE);
      if (maintenanceAlert) {
        enqueueAlert({
          type: AlertType.MAINTENANCE,
          position: AlertPosition.TOP,
          content: maintenanceAlert.message,
        });
        return;
      }
      
      // EMERGENCY와 MAINTENANCE가 모두 없는 경우 INFO 표시 (기존 로직)
      const infoAlert = systemAlertList.find(alert => alert.type === SystemAlertType.INFO);
      if (infoAlert) {
        enqueueAlert({
          type: AlertType.ALERT,
          position: AlertPosition.TOP,
          content: infoAlert.message,
        });
      }
    }
  }, [systemAlertList]);
}